import InstanceDetails from './entities/instance-details';
import InstanceRegister from './entities/instance-register';
import InstanceSubscriptionReview from './entities/instance-subscription-review';
import InstanceSubscriptionOptions from './entities/instance-subscription-options';
import InstanceRegistrationCheckout from './entities/instance-registration-checkout';
import InstanceSettingsReginalAndLanguage from './entities/instance-settings-reginal-and-language';
import InstanceCheckSubdomainAvailability from './entities/instance-check-subdomain-availability';
import InstanceCheckSubdomainAndEmailAvailability from './entities/instance-check-subdomain-and-email-availability';

import InstanceSourcesList from './entities/instance-sources-list';
import InstanceSourceDetails from './entities/instance-source-details';

import InstanceSubscriptionsList from './entities/instance-subscriptions-list';
import InstanceSubscriptionsDetails from './entities/instance-subscriptions-details';

import InstanceSubscriptionInvoicesList from './entities/instance-subscription-invoices-list';
import InstanceSubscriptionInvoiceDetails from './entities/instance-subscription-invoice-details';

import InstanceRegistrationCompletion from './entities/instance-registration-completion';
import InstanceRegistrationPreCompletion from './entities/instance-registration-pre-completion';

import InstanceInfo from './entities/instance-info';

import InstancePlanPurchaseSubscriptionOptions from './entities/instance-plan-purchase-subscription-options';
import InstancePlanPurchaseFinalReview from './entities/instance-plan-purchase-final-review';
import InstancePlanPurchaseCheckout from './entities/instance-plan-purchase-checkout';

import InstanceSubscribedPlanSummarized from './entities/instance-subscribed-plan-summarized';

import InstanceRegistrationResendCompletionToken from './entities/instance-registration-resend-completion-token';

export default {
  modules: {
    InstanceInfo,
    InstanceDetails,
    InstanceRegister,
    InstanceSubscriptionReview,
    InstanceSubscriptionOptions,
    InstanceRegistrationCheckout,
    InstanceCheckSubdomainAvailability,
    InstanceSettingsReginalAndLanguage,
    InstanceCheckSubdomainAndEmailAvailability,
    InstanceSourcesList,
    InstanceSourceDetails,
    InstanceSubscriptionsList,
    InstanceSubscriptionsDetails,
    InstanceRegistrationCompletion,
    InstanceRegistrationPreCompletion,
    InstancePlanPurchaseSubscriptionOptions,
    InstancePlanPurchaseFinalReview,
    InstancePlanPurchaseCheckout,
    InstanceSubscribedPlanSummarized,
    InstanceSubscriptionInvoicesList,
    InstanceSubscriptionInvoiceDetails,
    InstanceRegistrationResendCompletionToken,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/instance/index.js